import { useState, useRef, useEffect, useContext } from "react";
import { Space, Input, Button, Spin, Modal, App } from "antd";
import {
  CloseOutlined,
  SaveOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import MainContext from "@/layouts/MainLayout/context";

import { updateFolder, deleteMenuItem } from "@/api/definitionsMenu";

const ViewFolder = ({ uuid, name, onChange }) => {
  const { message } = App.useApp();
  const { refreshResources } = useContext(MainContext);

  const [isEdit, setIsEdit] = useState(false);
  const [folderName, setFolderName] = useState(name);
  const [newName, setNewName] = useState(name);

  const [pending, setPending] = useState(false);

  const inputRef = useRef();

  const onSave = async () => {
    if (!newName) {
      return;
    }

    setPending(true);
    try {
      const item = await updateFolder({ uuid, name: newName });
      setFolderName(item.name);
      refreshResources();
    } catch (error) {
      console.error(error);
    } finally {
      setPending(false);
    }
    setIsEdit(false);
  };

  const onClear = () => {
    setNewName(folderName);
    setIsEdit(false);
  };

  useEffect(() => {
    if (isEdit && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEdit]);

  const handleDeleteFolder = () => {
    Modal.confirm({
      title: `Вы уверены, что хотите удалить папку ${folderName}?`,
      content:
        "Все папки и отображения, находящиеся внутри, будут удалены насовсем.",
      onOk() {
        handleConfirmDelete();
      },
      okText: "Удалить",
      cancelText: "Отмена",
    });
  };

  const handleConfirmDelete = async () => {
    setPending(true);

    try {
      await deleteMenuItem({ uuid });
      await onChange();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      {isEdit ? (
        <Spin spinning={pending} style={{ display: "inline-block" }}>
          <Space
            style={{
              background: "var(--color-white)",
              marginRight: "-4px",
            }}
          >
            <Input
              ref={inputRef}
              value={newName}
              size="small"
              placeholder="Название группы"
              onChange={(e) => setNewName(e.target.value)}
            />

            <div>
              <Button
                size="small"
                type="link"
                icon={<SaveOutlined />}
                onClick={onSave}
              ></Button>
              <Button
                size="small"
                type="link"
                icon={<CloseOutlined />}
                onClick={onClear}
              ></Button>
            </div>
          </Space>
        </Spin>
      ) : (
        <Space>
          {folderName}
          <div>
            <Button
              size="small"
              type="link"
              icon={<EditOutlined />}
              onClick={() => setIsEdit(true)}
            />
            <Button
              size="small"
              type="link"
              icon={<DeleteOutlined />}
              onClick={handleDeleteFolder}
            />
          </div>
        </Space>
      )}
    </>
  );
};

export default ViewFolder;
